import api from '@/utils/api';
import {
    GET_MONITORING_MISSING_TREATMENT_SESSIONS
} from './types';
import { NotificationManager } from 'react-notifications';

/**
 * Lấy danh sách phiếu điều trị chưa nhập (monitoring)
 *
 * @param {Object} filter
 *  - page
 *  - limit
 */
export const getMonitoringMissingTreatmentSessions = (filter = {}) => dispatch => {
    return new Promise((resolve, reject) => {
        api.get('/monitorings/missing-treatment-sessions', {
            params: filter
        })
            .then(res => {
                const data = res.data?.data || {};

                dispatch({
                    type: GET_MONITORING_MISSING_TREATMENT_SESSIONS,
                    payload: data
                });

                resolve(data);
            })
            .catch(err => {
                console.error(err);

                NotificationManager.error(
                    err.response?.data?.msg || 'Không thể tải dữ liệu giám sát'
                );

                reject(err);
            });
    });
};
